import './modules/_toggle-state';
import './modules/primary-header';
import './modules/slider-image-text';
import './modules/slider-links';
import './modules/slider-highlighting';
import './modules/dropdown';
import './modules/form.ts';
import './modules/corner-realisation.ts';
/*
	BEWARE
	when you update the scripts, you need to copy the bundle generated in convert it in babel compiler (https://babeljs.io/repl).
	Than move the transpiled version to application/assets/legacy.js
	the lagacy file is loaded in layout-footer.twig
	This fix is required as far as we support IE11
*/
